import { useQuery } from '@tanstack/react-query';
import { createBalanceReader, createRpcClient } from '@gonka-wallet/chain';
import { useSettingsStore } from '../stores/settingsStore.js';
import { resolveSeeds } from '../lib/resolveSeeds.js';

export function useBalance(address: string | null) {
  const source = useSettingsStore((s) => s.chainNodeSource);
  const customUrl = useSettingsStore((s) => s.customNodeUrl);

  return useQuery({
    queryKey: ['balance', address, source, customUrl],
    queryFn: async () => {
      if (!address) return null;
      const seeds = resolveSeeds(source, customUrl);
      const client = createRpcClient(seeds);
      const reader = createBalanceReader(client, null);
      return reader.get(address);
    },
    enabled: !!address,
    staleTime: 15_000,
  });
}
